import { Facet, FacetState, FacetWrapperComponentConfig, FacetWrapperComponentModel, HawkSearchComponents } from '@models';
import { BaseComponent } from '../../base.component';
import { BaseFacetComponent } from '../facet-types/base-facet.component';
import defaultHtml from './facet-wrapper.component.hbs';

export class FacetWrapperComponent extends BaseComponent<FacetWrapperComponentConfig, Facet, FacetWrapperComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'facet-wrapper';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = false;

    state!: FacetState;

    protected override renderContent(): boolean {
        return !!this.data?.visible;
    }

    protected override getContentModel(): FacetWrapperComponentModel {
        return {
            ...this.data!,
            collapsed: this.state.collapsed ?? this.data!.collapsed ?? false,
            filter: this.state.filter ?? '',
            searchable: !!this.data!.search && (this.data!.values?.length ?? 0) > this.data!.search.threshold
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-facet-heading]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                if (this.data?.collapsible) {
                    this.state.collapsed = !this.state.collapsed;

                    this.render();
                }
            });
        });

        this.rootElement.querySelectorAll('[hawksearch-facet-search]').forEach((e) => {
            e.addEventListener('keyup', (event: Event) => {
                const element = event.currentTarget as HTMLInputElement;
                const value = element.value?.trim();

                this.state.filter = value ? value : undefined;

                this.rebindChildElements();
            });
        });

        this.rootElement.querySelectorAll<BaseFacetComponent<any, any>>('[hawksearch-facet]').forEach((component) => {
            component.data = this.data;
            component.state = this.state;
        });
    }

    private rebindChildElements(): void {
        this.rootElement.querySelectorAll<BaseFacetComponent<any, any>>('[hawksearch-facet]').forEach((component) => {
            component.render();
        });
    }
}
